module.exports = __webpack_public_path__ + "img/people-info1.9186e5ac.png";